import {connect} from "react-redux";
import Booking from "./Booking";
import {
    getBookingList,
    getNavParams,
    getStatusList,
    setBookingListFromCache,
    setBookingStatus,
    setNavParamsFromCache
} from "./actions";
import {compose} from "redux";
import {WithAppendHeaderAndFooterHOC} from "../../HOC/WithAppendHeaderAndFooterHOC";
import {WithAppendSidebarHOC} from "../../HOC/WithAppendSidebarHOC";
import {WithModeratorSearchHOC} from "../../HOC/WithModeratorSearchHOC";
import {searchObjects} from "../Objects/actions";
import {getUserRoleSelector} from "../../globalState/app/selectros";
import {WithSavingSnackBar} from "../../HOC/WithSavingSnackBar";
import {WithObjectComponentHOC} from "../../HOC/WithObjectComponentHOC";


let mapStateToProps = (state, props) => {

    return {
        headerSubtitle: props.inObject,
        bookings: state.bookingsPage.bookings,
        statusList: state.bookingsPage.statusList,
        navParams: state.bookingsPage.navParams,
        filter: state.bookingsPage.filter,
        userRole: getUserRoleSelector(state),
    }
};


export default compose(connect(mapStateToProps, {
    getBookingList,
    getStatusList,
    setBookingListFromCache,
    getNavParams,
    setNavParamsFromCache,
    searchObjects,
    setBookingStatus
}), WithObjectComponentHOC, WithAppendHeaderAndFooterHOC, WithAppendSidebarHOC, WithModeratorSearchHOC, WithSavingSnackBar)(Booking);



